import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M32.003 18.963a6.513 6.513 0 0 1-6.505-6.505 6.513 6.513 0 0 1 6.505-6.505 6.513 6.513 0 0 1 6.505 6.505 6.513 6.513 0 0 1-6.505 6.505Zm0-10.01a3.51 3.51 0 0 0-3.505 3.505 3.51 3.51 0 0 0 3.505 3.505 3.51 3.51 0 0 0 3.505-3.505 3.51 3.51 0 0 0-3.505-3.505ZM34.342 55.099h-4.45a.259.259 0 0 1-.26-.248l-.809-17.547h-2.991a.26.26 0 0 1-.26-.257l-.067-12.822 6.498-1.722 6.504 1.724v13.077h-3.324l-.82 17.784 3.04-.815.645-13.969h3.46V21.92l-9.505-2.52-9.51 2.521.08 15.143a3.267 3.267 0 0 0 3.259 3.241h.126l.677 14.685a3.254 3.254 0 0 0 3.256 3.11h5.255l-.804-3Z"
      }
    )
  }
);
export {
  r as MensToilet
};
